// AppointmentTabs/VehicleDetail.jsx
import React, { useState } from "react";
import Classes from "./AppointmentTabs.module.css";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function VehicleDetails({ loading, user }) {
  const [expanded, setExpanded] = useState('panel0');
  const vehicles = user?.customerProfile?.vehicle?.vehicles || [];

  const handleChange = (panel) => (_, isExpanded) => setExpanded(isExpanded ? panel : false);

  return (
    <section className={Classes.panel}>
      <h3 className={Classes.title}>Vehicle Details</h3>

      {(!vehicles.length) && <div className={Classes.muted}>No vehicles found.</div>}

      {vehicles.map((v, index) => (
        <Accordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
          sx={{ border: 'none', boxShadow: 'none', mb: '0', '&:before': { display: 'none' } }}
        >
          <AccordionSummary
            id={`panel${index}bh-header`}
            expandIcon={<ExpandMoreIcon />}
            sx={{
              minHeight: 10,
              padding: 0,
              '&.Mui-expanded': {
                minHeight: 10,
                margin: 0,
              },
              '& .MuiAccordionSummary-content': {
                margin: 0,
              },
              '& .MuiAccordionSummary-content': { margin: 0 },
              '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
            }}
          >
            <div className={Classes.AccordionHeader}>
              <h5>{`Vehicle ${index + 1}`}</h5>
            </div>
          </AccordionSummary>
          <AccordionDetails className={Classes.accordinBody}
            sx={{
              padding: '8px 0',
            }}
          >
            <div className={Classes.row}><p className={Classes.label}>Vehicle Make</p><p className={`${Classes.value} ${Classes.muted}`}>{v.make || "—"}</p></div>
            <div className={Classes.row}><p className={Classes.label}>Vehicle Model</p><p className={`${Classes.value} ${Classes.muted}`}>{v.model || "—"}</p></div>
            <div className={Classes.row}><p className={Classes.label}>License Plate</p><p className={`${Classes.value} ${Classes.muted}`}>{v.plate || "—"}</p></div>
          </AccordionDetails>
        </Accordion>
      ))}
    </section >
  );
}
